export const isInFullScreen = (): boolean => {
    return (
        (window as any).document.webkitIsFullScreen
    || (window as any).document.mozFullScreen
    || (window as any).document.msFullscreenElement === null
    );
};

export const exitFullScreen = (): void => {
    if ((window as any).document.cancelFullScreen) {
        (window as any).document.cancelFullScreen();
    } else if ((window as any).document.mozCancelFullScreen) {
        (window as any).document.mozCancelFullScreen();
    } else if ((window as any).document.webkitCancelFullScreen) {
        (window as any).document.webkitCancelFullScreen(
            (Element as any).ALLOW_KEYBOARD_INPUT
        );
    }
};

export const enterFullScreen = (): void => {
    if ((window as any).document.fullScreenElement) {
        (window as any).document.documentElement.requestFullScreen();
    } else if ((window as any).document.documentElement.mozRequestFullScreen) {
        (window as any).document.documentElement.mozRequestFullScreen();
    } else if ((window as any).document.documentElement.webkitRequestFullScreen) {
        (window as any).document.documentElement.webkitRequestFullScreen();
    }
};
